// extracted by mini-css-extract-plugin
module.exports = {"header":"App_header__2L3DO"};